import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from '@bibliocommons/utils-routing';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import { searchEventComposer } from '@bibliocommons/analytics-event-composers';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { libraryShape, routerShape } from '@bibliocommons/bc-prop-types';

import injectLibrary from 'app/components/hocs/injectLibrary';
import updateSearchQuery from '../../helpers/search/updateSearchQuery';
import BroadenSearchInfoPopOver from './BroadenSearchInfoPopOver/BroadenSearchInfoPopOver';

import './BroadenSearchLink.scss';

export class BroadenSearchLink extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getSearchURL(query) {
    const { router } = this.props;

    const newQuery = updateSearchQuery({
      currentQuery: router.query,
      page: undefined,
      lastSearchScope: router.query.searchScope,
      ...query
    });

    return { query: newQuery };
  }

  handleBroadenClick(e) {
    const { isBroadened, query, searchType, broadenedSearchType, router, library } = this.props;
    const lastSearchScope = router.query.lastSearchScope;

    e.preventDefault();

    if (searchType !== 'keyword') {
      const href = this.getSearchURL({
        searchType: 'keyword',
        searchScope: isBroadened && lastSearchScope
      });
      return this.props.router.push(href);
    }

    if (broadenedSearchType && !isBroadened) {
      sendAnalyticsEvents(
        searchEventComposer.composeBroadenSearchEvent({
          query,
          searchType: broadenedSearchType
        })
      );

      const newScope = library.get('broadenScope', false) ? { searchScope: this.getBroadenedScope() } : {};

      const href = this.getSearchURL({
        ...newScope,
        searchType: broadenedSearchType
      });

      return this.props.router.push(href);
    }

    return null;
  }

  getBroadenedScope() {
    const { scopes } = this.props;
    return scopes && scopes.first() && scopes.first().get('scopeId');
  }

  render() {
    const { isBroadened, broadenedSearchType, searchType, query } = this.props;

    const label = searchType !== 'keyword' ? 'form_label_expand_to_keyword' : 'empty_broaden_your_search';
    
    const validSearchType = !['keyword', 'bl'].includes(searchType);
    const canBroaden = broadenedSearchType;
    if (validSearchType || canBroaden || isBroadened) {
      return (
        <div className="cp-broaden-search-link">
          <a href="#broaden-search" onClick={this.handleBroadenClick} className="broaden-search-link">
            <FormattedMessage id={label} values={{ query }} />
          </a>
          {((validSearchType || canBroaden) && searchType === 'keyword') && <BroadenSearchInfoPopOver />}
        </div>
      );
    }

    return null;
  }
}

BroadenSearchLink.displayName = 'BroadenSearchLink';

BroadenSearchLink.propTypes = {
  broadenedSearchType: PropTypes.string,
  isBroadened: PropTypes.bool,
  router: routerShape,
  query: PropTypes.string,
  searchType: PropTypes.string,
  scopes: ImmutablePropTypes.list,
  library: libraryShape
};

export default withRouter(
  injectLibrary(({ site }) => ({
    scopes: site.get('scopes')
  }))(BroadenSearchLink)
);
